module.exports = __webpack_public_path__ + "static/media/bag-gels-unlimited.62751161.png";